import { useCustomFieldStore } from "./useCustomFieldStore.js";
import { ref, onMounted } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
export default {
  name: "DeleteCustomFieldsModal",
  components: {
    LlSecondaryButton
  },
  setup(props, {
    emit
  }) {
    const customFieldStore = useCustomFieldStore();
    const loading = ref(true);
    onMounted(() => {
      getSummary();
    });
    const getSummary = async () => {
      loading.value = true;
      await customFieldStore.loadCustomFieldSummary(customFieldStore.customFieldToDelete.id);
      loading.value = false;
    };
    function handleCloseButton() {
      customFieldStore.toggleDeleteCustomFieldsModal(null);
    }
    function deleteNow() {
      emit("close", customFieldStore.customFieldToDelete.id);
    }
    return {
      deleteNow,
      customFieldStore,
      handleCloseButton
    };
  }
};